<template>
  <div class="aci">
    <div class="box-head">Allosteric Coupling Intensity</div>

    <div class="box-tool">
      <a :href="$store.state.host+`/dokhlab/actions/ohm/result?id=${task.id}&file=aci-png`">{{task.id}}-nodes.png</a>, <a :href="$store.state.host+`/dokhlab/actions/ohm/result?id=${task.id}&file=aci&as=${task.id}-aci.txt`">{{task.id}}-aci.txt</a>
    </div>

    <div v-if="!showACI">
      <el-button type="text" @click.native="viewACI">View ACI</el-button>
    </div>

    <div style="overflow-x:auto" v-show="showACI">
      <div :style="canvasStyle">
        <canvas ref="aciBar" id="nodes-bar"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import interpolate from 'color-interpolate'
import Chart from 'chart.js'
// import { saveAs } from 'file-saver'

export default {
  name: 'Aci',

  data () {
    return {
      showACI: false,
      canvasStyle: {
        width: '100%',
        height: '400px'
      }
    }
  },

  props: [ 'value' ],

  computed: {
    task () {
      return this.$store.state.task
    }
  },

  methods: {
    viewACI () {
      this.showACI = true
      this.$nextTick(() => {
        this.checkTask()
      })
    },

    redirect (url) {
      window.location.href = url
    },

    openNewTab (url) {
      window.open(url, '_blank')
    },

    getInd (chainName, resNum) {
      for (let i of this.task.results.ind) {
//        console.log(JSON.stringify(i))
//        console.log(`${chainName}/${resNum}`)
        if (`${chainName}/${resNum}` === i.name) {
          return i.num
        }
      }
      return -1
//      return this.task.results.ind.find(i => i.name === `${chainName}/${resNum}`).num
    },

    checkTask () {
      let v = this
      if (this.task) {
        v.canvasStyle.width = `${v.task.results.ind.length * 20}px`
        let data = v.task.results.nodes
        let labels = v.task.results.ind.map(i => i.name)
        let colormap = interpolate(['blue', 'green', 'yellow', 'red'])
        let colors = v.task.results.nodes.map(i => {
  //        var color = r2h(interpolateColor([0, 0, 255], [255, 0, 0], i))
  //        console.log(i)
          var color = colormap(i)
  //        console.log(color)
          return color
        })
  //      let data = [1, 2, 3]
  //      let options = {}
        let barChart = new Chart(v.$refs.aciBar.getContext('2d'), {
          type: 'bar',
          data: {
            labels: labels,
            datasets: [{
              label: 'Allosteric Coupling Intensity',
              data: data,
              backgroundColor: colors,
              borderColor: colors,
              borderWidth: 1
            }]
          },
          options: {
            legend: {
              display: false
            },

            maintainAspectRatio: false,

            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true
                }
              }]
            }
          }
        })
//        console.log(barChart)
      } else {
        setTimeout(() => {
          v.checkTask()
        }, 500)
      }
    }
  },

  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/theme.scss";


#paths-bar {
  width: 100%;
  height: 100%;
}

.aci {
  margin: 20px 0px;
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -ms-user-select: none;
}

.box-head {
  padding: 10px;
  border-bottom: 1px solid #eeeeee;
  background-color: $theme-color;
  font-weight: 700;
  color: white;
}

.box-tool {
  padding:10px 0px;
}

</style>
